core.directive('timeInput', ['$parse',
    function($parse) {
        var definition = {
            require: '?ngModel',
            restrict: 'A',
            scope: {
                timeInput: '='
            },
            link: function(scope, element, attr, ngModelCtrl) {

                var currentTime = null;

                function getDateFromTime (timeStr) {
                    var d = new Date();
                    if(timeStr && timeStr.length === 5) {
                        d.setHours(timeStr.substr(0, 2), timeStr.substr(3, 2), 0 ,0);
                    } else {
                        d.setHours(0, 0, 0 ,0);
                    }
                    return d;

                }

                scope.$watch('timeInput', function (newVal) {
                    if(newVal) {
                        if(currentTime) {
                            newVal.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
                        } else {
                            newVal.setHours(0, 0, 0, 0);
                        }
                    }
                });

                scope.$watch(function(){
                    return ngModelCtrl.$modelValue;
                }, function(modelValue, old){
                    var val = modelValue, o = old;

                    if(!val) return;

                    if(val && val.match(/^[0-9]{2}:[0-9]{2}$/)) {

                    } else {
                        if(val.length === 4 && val[val.length-1] == ':') {
                            val = val.substr(0, 3);
                        }

                        if(val.length === 5) {
                            val = '00:00';
                        }
                    }

                    if(val.length === 2 && (!o || o.length < 2)) {
                        if(val[1] === ':') {
                            val = '0' + val;
                        } else
                            val = val + ':';
                    }

                    if(val.length > 5) {
                        val = val.substr(0, 5);
                    }

                    if(val.length === 1 && (!o || o.length < 1)) {
                        if(val > 2) {
                            val = '0' + val;
                        }
                    }

                    if(val.length === 5) {
                        var split = val.split(':');
                        var hours = split[0];
                        var minutes = split[1];
                        if(hours > 24) {
                            hours = '00';
                        }
                        if(minutes > 59) {
                            minutes = '00';
                        }
                        val = hours + ':' + minutes;
                    }

                    ngModelCtrl.$setViewValue(val);
                    ngModelCtrl.$render();

                    currentTime = getDateFromTime(val);
                    scope.timeInput.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);


                });
            }
        };

        return definition;
    }
]);